<template>
  <component
    :is="componentName"
    :is-create="true"/>
</template>

<script>
  import {mapGetters} from 'vuex'
  import ProfileFormCompany from './ProfileFormCompany'
  import ProfileFormUser from './ProfileFormUser'

  export default {
    name: 'ProfileCreate',
    components: {
      ProfileFormCompany,
      ProfileFormUser
    },
    computed: {
      ...mapGetters('profile', [
        'getCreateTypeId'
      ]),
      componentName: function () {
        return this.getCreateTypeId === 2 ? 'ProfileFormCompany' : 'ProfileFormUser'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Personal/PersonalProfile/ProfileCreate.vue